module.exports = __webpack_public_path__ + "img/Frame 1062two.af1ed686.png";